<template>
  <div class="warehouse">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList || []"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template v-slot="scope">
            <div v-if="item.field == 'isDirectDeliver'">
              <div v-if="scope.row.isDirectDeliver == '1'">
                {{ $t('addSupplierDelivery.option.direct') }}
              </div>
              <div v-if="scope.row.isDirectDeliver == '0'">
                {{ $t('addSupplierDelivery.option.notDirect') }}
              </div>
            </div>
            <div v-else>{{ scope.row[item.field] }}</div>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <SiruiUpload ref="siruiUpload" :action="action" :data="importData" @getData="getData" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/masterData/company.js';
  // import BASE_API from '@/api/dataBase.js';
  import SiruiUpload from '@/components/SiruiUpload';
  import { filterEmpty } from '@/common/js/util';

  export default {
    name: 'warehouse',
    components: {
      SiruiUpload,
    },
    mixins: [tableMixins],
    data() {
      return {
        query: {
          createWarehouseCode: null,
          createWarehouseName: null,
          currentStatus: null,
          isDirectDeliver: null,
        },
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'storageCode',
            title: 'warehouse.table.createWarehouseCode',
            visible: true,
          },
          {
            field: 'storageName',
            title: 'warehouse.table.createWarehouseName',
            visible: true,
          },
          {
            field: 'storageAddress',
            title: 'warehouse.table.createWarehouseAddress',
            visible: true,
          },
          {
            field: 'storageCompanyCode',
            title: 'warehouse.table.createWarehouseCompanyCode',
            visible: true,
          },
          {
            field: 'storageCompanyName',
            title: 'warehouse.table.createWarehouseCompanyName',
            visible: true,
          },
          {
            field: 'personName',
            title: 'warehouse.table.gmtCreateBy',
            visible: true,
          },
          {
            field: 'isDirectDeliver',
            title: 'warehouse.table.isDirectDeliver',
            visible: true,
          },
          {
            field: 'storageCreateTime',
            title: 'warehouse.table.gmtCreate',
            visible: true,
          },
          {
            field: 'currentName',
            title: 'warehouse.table.status',
            visible: true,
          },
        ],
        //是否直拨下拉
        directDeliverOptions: [
          { value: '1', label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionOne') },
          { value: '0', label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionTwo') },
        ],
      };
    },
    computed: {
      action() {
        return API.IMPORT_WAREHOUSE_API;
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'storageCode',
            name: this.$t('warehouse.search.warehouseCode'),
            type: 'input',
            placeholder: this.$t('warehouse.search.warehouseCodePlaceholder'),
          },
          {
            prop: 'storageName',
            name: this.$t('warehouse.search.warehouseName'),
            type: 'input',
            placeholder: this.$t('warehouse.search.warehouseNamePlaceholder'),
          },
          {
            prop: 'currentStatus',
            name: this.$t('company.search.status'),
            type: 'select',
            options: [
              { label: '审批中', value: 'ZT02' },
              { label: '已禁用', value: 'ZT04' },
              { label: '已保存', value: 'ZT06' },
              { label: '已生效', value: 'ZT03' },
              { label: '已驳回', value: 'ZT05' },
              { label: '审批中--已禁用', value: 'ZT07' },
            ],
            // apiUrl: BASE_API.DIC_CREDIT_API,
            // apiData: { dictType: "request_status"},
            placeholder: this.$t('company.search.statusPlaceholder'),
          },
          {
            prop: 'isDirectDeliver',
            name: this.$t('supplierDeliveryOrder.search.directDeliver'),
            type: 'select',
            placeholder: this.$t('supplierDeliveryOrder.search.isDirectDeliverPlaceholder'),
            options: this.directDeliverOptions,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          access_token: this.userInfo.userInfo.access_token,
        };
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
      });
    },
    methods: {
      //初始化数据列表
      getData() {
        const query = Object.assign({}, this.$refs.siruiSearch.query);
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query.companyCode = this.userInfo.userInfo.companyCode;
        query.adminFlag = this.userInfo.userInfo.adminFlag;
        this.load = true;
        this.$axios.post(API.GET_STORAGE_LIST, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.reloadTable(this.tableData);
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //双击查看详情
      dblclickEvent(tableData) {
        let path = {
          path: '/masterData/warehouseDetail',
          name: 'warehouseDetail',
          meta: {
            keepAlive: true,
            title: '仓库详情',
          },
          query: {
            storageCode: tableData.row.storageCode,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type, '点击按钮');
        if (type == 'add') {
          let path = {
            path: '/masterData/addWarehouse',
            name: 'addWarehouse',
            meta: {
              keepAlive: true,
              title: '创建仓库',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'forbid') {
          this.fotbidStorage();
        } else if (type == 'lift') {
          this.liftStorage();
        } else if (type == 'import') {
          this.importStorage();
        } else if (type == 'export') {
          this.exportStorage();
        } else if (type === 'reject') {
          this.handleReject('ZT05');
        } else if (type === 'approval') {
          this.handleReject('ZT03');
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //驳回,审批
      handleReject(val) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        // 可多选
        let isRequestStatus = this.multipleSelection.every(
          (item) => item.currentStatus == 'ZT02' || item.currentStatus == 'ZT07'
        );
        let idList = [];
        this.multipleSelection.forEach((item) => {
          if (item.currentStatus == 'ZT02' || item.currentStatus == 'ZT07') {
            idList.push({
              id: item.id,
              version: item.version,
              currentStatus: item.currentStatus,
              storageCode: item.storageCode,
            });
          }
        });
        if (isRequestStatus) {
          let params = {
            storageDOList: idList,
            currentStatus: val,
          };
          this.$axios.post(API.UPDATE_IS_REJECT, params).then((res) => {
            if (res.data.code === 0) {
              this.$refs.siruiTable.clearCheckboxReserve();
              this.getData();
              this.multipleSelection = [];
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.importError'),
            type: 'error',
          });
        }
      },
      //禁用仓库
      fotbidStorage() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidNoTips'),
            type: 'error',
          });
          return;
        }
        let forbid = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].currentStatus != 'ZT03') {
            forbid = false;
          }
        }

        if (!forbid) {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidNoReason'),
            type: 'error',
          });
          return;
        }
        //非管理员需要填写禁用原因
        if (this.userInfo.userInfo.adminFlag == '2') {
          var specialValidate = (value) => {
            if (value == null || value == '') {
              return this.$t('warehouse.forbidReasonNotEmpty');
            } else {
              return true;
            }
          };

          this.$prompt(
            "<div><img src='./static/img/tips.png'/><div class='confirmTitle'>" +
              this.$t('confirm.forbid') +
              '</div>' +
              "<div class='confirmContent'>" +
              this.$t('confirm.forbidContent') +
              '</div></div>',
            '',
            {
              customClass: 'prompt-box',
              dangerouslyUseHTMLString: true,
              cancelButtonText: this.$t('confirm.cancel'),
              confirmButtonText: this.$t('confirm.confirm'),
              inputPlaceholder: this.$t('warehouse.forbidReason'),
              center: true,
              inputValidator: specialValidate,
            }
          )
            .then(({ value }) => {
              const params = {
                currentStatus: 'ZT04',
                version: this.multipleSelection[0].version,
                storageCode: this.multipleSelection[0].storageCode,
                forbidReason: value,
                adminFlag: this.userInfo.userInfo.adminFlag,
              };
              this.loading.startLoading();
              this.$axios.post(API.UPDATE_STORAGE_STATUS_API, params).then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.getData();
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          //管理员直接禁用
          this.$confirmAction(this.$t('confirm.forbid'), this.$t('confirm.forbidContent'))
            .then(() => {
              const params = {
                currentStatus: 'ZT04',
                version: this.multipleSelection[0].version,
                storageCode: this.multipleSelection[0].storageCode,
                adminFlag: this.userInfo.userInfo.adminFlag,
              };
              this.loading.startLoading();
              this.$axios.post(API.UPDATE_STORAGE_STATUS_API, params).then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.getData();
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //启用仓库
      liftStorage() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('company.liftNoTips'),
            type: 'error',
          });
          return;
        }
        let forbid = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].currentStatus != 'ZT04') {
            forbid = false;
          }
        }
        if (!forbid) {
          this.$message({
            showClose: true,
            message: this.$t('company.liftNoReason'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.lift'), this.$t('confirm.liftContent'))
          .then(() => {
            const params = {
              currentStatus: 'ZT03',
              version: this.multipleSelection[0].version,
              storageCode: this.multipleSelection[0].storageCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            };
            this.loading.startLoading();
            this.$axios.post(API.UPDATE_STORAGE_STATUS_API, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //导入
      importStorage() {
        this.$refs.siruiUpload.openDialog(true);
      },
      //导出
      exportStorage() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        //如果当前页和历史页没有记录 ，则看搜索区域
        // let count = isSearchEmpty(this.query, this.$refs.siruiSearch.query);
        // if (
        //   this.multipleSelection.length == 0 &&
        //   selectedList.length == 0 &&
        //   count == 0
        // ) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t("company.noExportTips"),
        //     type: "error"
        //   });
        //   return;
        // }

        const query = this.$refs.siruiSearch.query;
        const params = filterEmpty(query);
        params.adminFlag = this.userInfo.userInfo.adminFlag;
        params.idsExport = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idsExport.push(item.storageCode);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idsExport.push(item.storageCode);
          });
        }
        this.loading.startLoading();
        // 获取数据
        this.$axios.post(API.EXPORT_WAREHOUSE_API, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
